import { affiliateConstants } from '../constants/affiliateConstants';
import { affiliateService } from '../../services/API/affiliateService';
import { alertActions } from './alert.actions';
import { history }              from '../store/configureStore';
import Alert     from '../../components/alert/Alert';

export const affiliateActions = {
    add_affiliate,
    getCust_SalesManagerList,
    getAffiliateList,
    deleteAffiliate,
    getAffiliateDetails,
    update_affiliate,
    getAffiliateDashboard,
    getAffiliateDashboardByUser
};

export const  add_affiliate = (postData) => {
  return dispatch => {
    affiliateService.add_affiliate(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.ADD_AFFILIATE_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.ADD_AFFILIATE_SUCCESS, data } }
  function failure(error) { return { type: affiliateConstants.ADD_AFFILIATE_FAILURE, error } }
}

export const  getCust_SalesManagerList = () => {
  return dispatch => {
    affiliateService.getCust_SalesManagerList()
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.GET_CUST_SALES_LIST_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.GET_CUST_SALES_LIST_SUCCESS, data } }
  function failure(error) { return { type: affiliateConstants.GET_CUST_SALES_LIST_FAILURE, error } }
}

export const  getAffiliateList = (formData) => {
  return dispatch => {
    affiliateService.getAffiliateList(formData)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type:  affiliateConstants.GET_AFFILIATE_REQUEST, data } }
  function success(data) { return { type:  affiliateConstants.GET_AFFILIATE_SUCCESS, data } }
  function failure(error) { return { type: affiliateConstants.GET_AFFILIATE_FAILURE, error } }
}

export const  deleteAffiliate = (affiliateIdAsParam) => {
  return dispatch => {
    affiliateService.deleteAffiliate(affiliateIdAsParam)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.DELETE_AFFILIATE_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.DELETE_AFFILIATE_SUCCESS, data } }
  function failure(error) { return { type: affiliateConstants.DELETE_AFFILIATE_FAILURE, error } }
}

export const  getAffiliateDetails = (affiliateIdParams) => {
  return dispatch => {
    affiliateService.getAffiliateDetails(affiliateIdParams)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.GET_AFFILIATEDETAIL_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.GET_AFFILIATEDETAIL_SUCCESS, data } }
  function failure(error){ return { type:affiliateConstants.GET_AFFILIATEDETAIL_FAILURE, error } }
}

export const  update_affiliate = (postData) => {
  return dispatch => {
    affiliateService.update_affiliate(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.UPDATE_AFFILIATE_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.UPDATE_AFFILIATE_SUCCESS, data } }
  function failure(error) { return { type: affiliateConstants.UPDATE_AFFILIATE_FAILURE, error } }
}

export const  getAffiliateDashboard = (affiliateIdParams) => {
  return dispatch => {
    affiliateService.getAffiliateDashboard(affiliateIdParams)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.GET_AFFILIATE_DASHBOARD_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.GET_AFFILIATE_DASHBOARD_SUCCESS, data } }
  function failure(error){ return { type:affiliateConstants.GET_AFFILIATE_DASHBOARD_FAILURE, error } }
}

export const  getAffiliateDashboardByUser = (userIdParams) => {
  return dispatch => {
    affiliateService.getAffiliateDashboardByUser(userIdParams)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: affiliateConstants.GET_AFFILIATE_DASHBOARD_BYUSER_REQUEST, data } }
  function success(data) { return { type: affiliateConstants.GET_AFFILIATE_DASHBOARD_BYUSER_SUCCESS, data } }
  function failure(error){ return { type:affiliateConstants.GET_AFFILIATE_DASHBOARD_BYUSER_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/affiliateActions.js